import axios, { CancelTokenSource } from "axios";

import { ApiResponse, ExtensionDetails } from "src/types";
import { API_URLS } from "src/utils/API_URLS";

const ExtensionsService = {
  getDetails: async (
    wsExtensionUuid: string,
    cancelToken: CancelTokenSource,
  ): Promise<ExtensionDetails> => {
    try {
      const url = API_URLS.getExtensionDetails.replace(
        ":wsExtensionUuid:",
        wsExtensionUuid,
      );
      const response = await axios.get<ApiResponse<ExtensionDetails>>(url, {
        cancelToken: cancelToken.token,
      });
      return response.data.content;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

export default ExtensionsService;
